module.exports = __webpack_public_path__ + "statics/media/ad.8aad201d.webm";